document.addEventListener("DOMContentLoaded", () => {
  handleProductPageAccordions();
  handleCollectionDescriptionClick();
});

function handleProductPageAccordions() {
  const accordionBtns = document.querySelectorAll(".accordion");

  if (accordionBtns.length) {
    const productInfoAccordion = accordionBtns[0];

    productInfoAccordion.classList.toggle("is-open")
    
    let productInfoContent = productInfoAccordion.nextElementSibling;
    productInfoContent.classList.toggle("is-open");

    if (productInfoContent.style.maxHeight) {
      productInfoContent.style.maxHeight = null;
    } else {
      productInfoContent.style.maxHeight = productInfoContent.scrollHeight + 10 + "px";
    }
    
    accordionBtns.forEach((accordion) => {
      accordion.onclick = function () {

        accordionBtns.forEach((innerAccordion) => {
          if (this !== innerAccordion) {
            innerAccordion.classList.remove("is-open");
            innerAccordion.nextElementSibling.classList.remove("is-open");
            innerAccordion.nextElementSibling.style.maxHeight = null;
          }
        })

        this.classList.toggle("is-open");
    
        const content = this.nextElementSibling;
  
        content.classList.toggle("is-open");
    
        if (content.style.maxHeight) {
          content.style.maxHeight = null;
        } else {
          content.style.maxHeight = content.scrollHeight + 10 + "px";
        }
      };
    });
  }
}

function handleCollectionDescriptionClick() {
  const lengthToggles = [...document.querySelectorAll('[js-collection-description="lengthToggle"]')];
  const shortDescription = document.querySelector('[js-collection-description="short"]');
  const fullDescription = document.querySelector('[js-collection-description="full"]');

  if (!lengthToggles || !shortDescription || !fullDescription) {
    return;
  }

  lengthToggles.forEach((toggle) => {
    toggle.addEventListener("click", () => {
      shortDescription.classList.toggle('is-hidden');
      fullDescription.classList.toggle('is-hidden');
    });
  });
}